import Handlebars from 'handlebars'

/**
 * Retrieves a Handlebars templates from a static file via AJAX and processes it based on the provided parameters.
 *
 * @param {string} staticFileURL - The URL of the static file containing the Handlebars template.
 * @param {string} [partialName] - Optional. If provided, registers the compiled template as a Handlebars partial with the given name.
 * @param {Object} [ctx] - Optional. If provided, renders the compiled template with the specified context data.
 * @returns {Promise<Function|string>} A Promise that resolves to either a compiled Handlebars template function, a registered partial, or a rendered template string.
 * @throws {Error} Throws an error if both `partialName` and `ctx` are provided simultaneously.
 */
export const getTemplate = function (staticFileURL, partialName, ctx) {
    if (partialName && ctx) {
        throw Error(
            "You cannot call `getTemplate` with `partialName` and `ctx`"
        );
    }
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: staticFileURL,
            success: function (data) {
                let hb_compiled = Handlebars.compile(data);
                if (partialName) {
                    resolve(
                        Handlebars.registerPartial(partialName, hb_compiled)
                    );
                    return this;
                } else if (ctx) {
                    resolve(renderTemplate(hb_compiled, ctx));
                    return this;
                } else {
                    resolve(hb_compiled);
                    return this;
                }
            },
            error: function (r) {
                reject(r);
            },
        });
    });
};
/**
 * Renders a Handlebars template with the provided context data.
 *
 * @param {Function} template - The compiled Handlebars template function to be rendered.
 * @param {Object} ctx - The context data to be used during template rendering.
 * @returns {string} The rendered template as a string.
 */
const renderTemplate = function (template, ctx) {
    return template(ctx);
};

Handlebars.registerHelper('pluralise', function(number, single, plural) {if (number === 1) { return single; }else { return plural; }});

/**
 * Handlebars helper to convert line breaks in a string to HTML line breaks.
 *
 * @param {string} text - The text to be processed.
 * @returns {SafeString} A Handlebars SafeString containing the processed text.
 *
 */
Handlebars.registerHelper('linebreaksbr', function(text) {

    if (typeof text !== 'string') {
        return '';
    }
    text = Handlebars.Utils.escapeExpression(text);
    text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
    return new Handlebars.SafeString(text);
});
